export const Breakpoints = {
  small: '@media screen and (max-width: 600px)',
  medium: '@media screen and (max-width: 960px)',
  large: '@media screen and (max-width: 1280px)',
  xLarge: '@media screen and (min-width: 1281px)',
}
